
import { Pipe, PipeTransform } from '@angular/core';
import { GroupTypeColors, GroupTypeEnum } from '../models/group.model';
import { BadgeVariant } from '@pansa/ui';

@Pipe({
  name: 'groupColor'
})
export class GroupColorPipe implements PipeTransform {
  transform(value: GroupTypeEnum | undefined): BadgeVariant {
    if(value){
      return GroupTypeColors[value];
    }
    return 'info'
  }
}
